import { useLocation } from 'react-router-dom';
import Navigation from './Navigation';

const NavbarHandler = () => {
  const location = useLocation();
  const path = location.pathname;

  // Only show the public Navigation component on non-admin, non-customer routes
  if (path.startsWith('/admin') || path.startsWith('/customer')) {
    return null; // Return nothing for admin/customer paths
  } else {
    return <Navigation />;
  }
};

export default NavbarHandler;